const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/work-integrations/$integrationId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/work-integrations/$integrationId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: requirePermission('edit_integrations'),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.settings['work-integrations'].detail.backLink)
  })
});